// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorBox-module__error___3BB1B"};